import {
Component, Input, Output, EventEmitter,
} from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {
  @Input() title: string;
  @Input() customClasses: string;
  @Input() isButton = true;
  @Input() isDisabled = false;
  @Input() isLorealDesign = false;
  @Input() isVTO = false;
  @Input() isGoogle = false;
  @Input() isFacebook = false;
  @Input() isApple = false;
  @Input() isLoading = false;
  @Input() isTemplate = false;
  @Input() buttonId = '';
  @Input() srcImg: string;
  @Input() sideImg: string;
  @Input() srcClass: string;
  @Input() productCuf = '';
  @Input() spinnerBlue = false;
  @Output() clicked = new EventEmitter();
  @Input() color = '';
  @Input() isCart = false;
  @Input() isFlashOffer = false;
  @Input() bgColor = null;

  click() {
    this.clicked.emit(true);
  }

  getCustomStyle() {
    const customStyle = {'background-color': this.bgColor || ''};
    if(this.bgColor) customStyle['border-color'] = this.bgColor;
    return customStyle;
  }

  get shouldShowLeftImage(): boolean {
    return this.srcImg && this.sideImg === 'left';
  }

}
